import api from '@api';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
    patchMultipleReceivingsFetchFailure,
    patchMultipleReceivingsFetchSuccess,
    patchReceivingFetchFailure,
    patchReceivingFetchSuccess,
    synchronizeReceivingsDCIXFetchFailure,
    synchronizeReceivingsDCIXFetchSuccess
} from './reducer';

import { getReceivingsGridFetch } from '../receivingsGrid/reducer'; // Importuj akci pro načítání gridu přijatých zásob
import translate from '@translate';
import { ReceivingType } from 'src/types/receiving';

// Funkce pro API volání
const patchReceivingFetchRequest = async (receiving: ReceivingType, data: ReceivingType) => {
    const res = await api('patch', `api/secure/receivings/${receiving.ID}`, data);
    return res.data;
};

// Saga pro jedno API volání
function* patchReceivingFetch(action: { type: string; payload: { receiving: ReceivingType; data: ReceivingType } }) {
    const { receiving, data } = action.payload;

    try {
        yield call(() => patchReceivingFetchRequest(receiving, data));
        yield put(patchReceivingFetchSuccess());
    } catch (error) {
        yield put(patchReceivingFetchFailure({ error }));
    }
}

// Watcher pro jednotlivé API volání
export function* patchReceivingFetchWatch() {
    yield takeEvery('receivingsUpdate/patchReceivingFetch', patchReceivingFetch);
}

// Saga pro zpracování více přijatých zásob
function* patchMultipleReceivingsFetch(action: {
    type: string;
    payload: { receivings: ReceivingType[]; data: ReceivingType }
}) {
    const { receivings, data } = action.payload;
    const batchSize = 10; // Nastav velikost stránky (počet přijatých zásob na jednu dávku)

    try {
        // Rozdělení receivings na menší dávky
        for (let i = 0; i < receivings.length; i += batchSize) {
            const chunk = receivings.slice(i, i + batchSize);

            // Zpracování každé dávky samostatně
            yield all(
                chunk.map((receiving) =>
                    call(patchReceivingFetch, {
                        type: 'receivingsUpdate/patchReceivingFetch',
                        payload: { receiving, data }
                    })
                )
            );
        }

        yield put(patchMultipleReceivingsFetchSuccess());
        yield put(getReceivingsGridFetch(undefined)); // Načtení gridu přijatých zásob
    } catch (error) {
        yield put(patchMultipleReceivingsFetchFailure({ error }));
        yield put(getReceivingsGridFetch(undefined)); // Načtení gridu přijatých zásob
    }
}

// Watcher pro zpracování více přijatých zásob
export function* patchMultipleReceivingsFetchWatch() {
    yield takeEvery('receivingsUpdate/patchMultipleReceivingsFetch', patchMultipleReceivingsFetch);
}

const synchronizeReceivingsDCIXFetchRequest = async (receivings: ReceivingType[]) => {
    const res = await api('post', `api/secure/dcix/import/receivings`, { keys: receivings.map((item) => item.ID) });
    return res.data;
};

function* synchronizeReceivingsDCIXFetch(action: { type: string; payload: ReceivingType[] }) {
    try {
        yield call((): any => synchronizeReceivingsDCIXFetchRequest(action.payload));
        yield put(
            synchronizeReceivingsDCIXFetchSuccess({
                messageSuccess: { title: translate('receivings.message.synchronizeSuccessfull') }
            })
        );
        yield put(getReceivingsGridFetch(undefined));
    } catch (error) {
        yield put(synchronizeReceivingsDCIXFetchFailure({ error }));
        yield put(getReceivingsGridFetch(undefined));
    }
}

export function* synchronizeReceivingsDCIXFetchWatch() {
    yield takeEvery('receivingsUpdate/synchronizeReceivingsDCIXFetch', synchronizeReceivingsDCIXFetch);
}
